import MarketingOptIn, { MarketingOptInTermsNotice } from './marketing-opt-in'

export { MarketingOptInTermsNotice }
export default MarketingOptIn
